import { ControlConstants } from "../../control/constant/ControlConstants";
import { SpineProperties } from "../../control/properties/SpineProperties";
import { TextFieldProperties } from "../../control/properties/TextFieldProperties";
import { CommonFontStyle } from "../style/CommonFontStyle";
import { PreloaderStyle } from "../style/CommonStyle";
import { AbstractViewProperties } from "./AbstractViewProperties";
/**
 * AbstractPreloaderProperties.ts
 */
export class AbstractPreloaderProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.spineProperties.equals(other.spineProperties) &&
            this.messageProperties.equals(other.messageProperties) &&
            this.rotatedMessageProperties.equals(other.rotatedMessageProperties) &&
            this.messageSpinePosition.equals(other.messageSpinePosition) &&
            this.rotatedMessageSpinePosition.equals(other.rotatedMessageSpinePosition) &&
            this.backgroundColour === other.backgroundColour;
    }
    setDefaultValues() {
        this.spineProperties = new SpineProperties(PreloaderStyle.PRELOADER, PreloaderStyle.PRELOADER);
        this.messageProperties = new TextFieldProperties(CommonFontStyle.PRELOADER_MESSAGE, null, null, ControlConstants.CENTER);
        this.rotatedMessageProperties = new TextFieldProperties(CommonFontStyle.PRELOADER_MESSAGE, null, null, ControlConstants.CENTER);
        this.backgroundColour = 0x103b45;
    }
}
//# sourceMappingURL=AbstractPreloaderProperties.js.map